import { render } from "./TermsOfExchangeAndRefundScreen.vue?vue&type=template&id=25eeac45&scoped=true"
const script = {}

import "./TermsOfExchangeAndRefundScreen.vue?vue&type=style&index=0&id=25eeac45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25eeac45"]])

export default __exports__